import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["code", "button"]

  async copy() {
    const text = this.codeTarget.textContent.trim()
    try {
      await navigator.clipboard.writeText(text)
      this.flash("Copied!")
    } catch (_e) {
      // Older browsers or non-HTTPS preview contexts — fall back to the
      // legacy execCommand path so the button is never just dead-clicking.
      const ta = document.createElement("textarea")
      ta.value = text
      ta.setAttribute("readonly", "")
      ta.style.position = "absolute"
      ta.style.left = "-9999px"
      document.body.appendChild(ta)
      ta.select()
      try { document.execCommand("copy"); this.flash("Copied!") }
      catch (_e2) { this.flash("Press ⌘+C") }
      finally { document.body.removeChild(ta) }
    }
  }

  flash(label) {
    const original = this.buttonTarget.textContent
    this.buttonTarget.textContent = label
    clearTimeout(this._t)
    this._t = setTimeout(() => { this.buttonTarget.textContent = original }, 1500)
  }
}
